import currencyToCountry from '@/data/currencyToCountry.json'
import type { IconFactor } from '@/types/elements/icon'

export const getCountryFlagIcon = (countryCode: string): IconFactor => {
  return {
    src: async () => import(`assets/img/svg/flags/4x3/${countryCode.toLowerCase()}.svg?raw`),
    size: '1.3rem',
    cacheKey: `flag-${countryCode}`
  }
}

export const getCurrencyFlagIcon = (currency: string): IconFactor | null => {
  const countryCode = currencyToCountry[currency as keyof typeof currencyToCountry]
  if (!countryCode) return null;
  return getCountryFlagIcon(countryCode);
}

export const getFlagIcon = (key?: string): IconFactor | null => {
  if (!key) return null;
  const countryCode = currencyToCountry[key as keyof typeof currencyToCountry]
  if (countryCode) return getCountryFlagIcon(countryCode);
  if (key.length <= 2) return getCountryFlagIcon(key);
  return null;
}
